export enum ScheduleDay {
  Sunday = 'Su',
  Monday = 'M',
  Tuesday = 'T',
  Wednesday = 'W',
  Thursday = 'Th',
  Friday = 'F',
  Saturday = 'S'
}

export type ScheduleType = 'OnlyOnce' | 'Random'

export type ScheduleTriggerType = 'Always' | 'Passed' | 'RunOnce'

export interface ScheduleWindow {
  start: string // in UTC, local to customer
  end: string // in UTC, local to customer
  numOfRuns: number
}

export interface ScheduleTrigger {
  dayOfWeek: ScheduleDay
  scheduleWindows: ScheduleWindow[]
}

export interface ScheduleSettings {
  enabled: boolean
  scheduleType?: ScheduleType
  triggerType?: ScheduleTriggerType
  triggers?: ScheduleTrigger[]
}
